var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content queryBilling" },
    [
      _c(
        "search-item",
        {
          key: _vm.identify,
          ref: _vm.identify,
          attrs: {
            "show-more-scheme": true,
            "show-simple": _vm.showSimple,
            "expand-adv": true,
            "search-item-code": _vm.searchItemCode,
            "config-module": _vm.configModule,
            "grid-config-module": _vm.gridConfigModule,
            "auto-init": _vm.searchItemAutoInit,
            "custom-search-items": _vm.customSearchItems,
            "custom-sim-query-placeholder": _vm.simQueryPlaceholder,
            "is-append-query": _vm.isAppendQuery,
            "col-settings": _vm.colSettings
          },
          on: {
            query: _vm.fetchData,
            advToggle: _vm.scrollCallback,
            perConfigChange: function(value) {
              _vm.perConfigName = value
            },
            refreshGrid: function() {
              _vm.gridRefreshId += 1
            },
            defaultSearchItemsChange: function(value) {
              _vm.defaultSearchItems = value
            }
          }
        },
        [
          _c("template", { slot: "operations" }, [_vm._t("operations")], 2),
          _c(
            "template",
            { slot: "searchAreaHeader" },
            [_vm._t("searchAreaHeader")],
            2
          )
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid-wrapper", {
            attrs: {
              "config-module": _vm.gridConfigModule,
              "per-config-name": _vm.perConfigName,
              "refresh-id": _vm.gridRefreshId,
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.dynamicColumnDefs,
              "sum-column-defs": _vm.sumColumnDefs,
              "row-data": _vm.rowData,
              "min-height": _vm.hasVoucher === 0 ? "350px" : "200px",
              "show-row-groups": _vm.dataListDragGroup
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pagination-wrapper",
          attrs: { id: "footer-wrapper-tab-billing" }
        },
        [
          _c(
            "div",
            {
              class: [_vm.shouldFixed ? "fixedBottom" : ""],
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "flex-wrap": "wrap"
              }
            },
            [
              _vm.dataShow &&
              ["tabBilling", "Writeoff"].includes(_vm.viewSource)
                ? _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.totalAmountToCurrencyBillingGrid.labelText
                      )
                    }
                  })
                : _vm._e(),
              _vm.dataShow &&
              ["tabBilling", "Writeoff", "VoucherList"].includes(_vm.viewSource)
                ? _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.totalAmountToCurrencyBillingGrid.selectionCountLabel
                      )
                    }
                  })
                : _vm._e(),
              _vm.reCalc &&
              ["tabBilling", "Writeoff", "VoucherList"].includes(_vm.viewSource)
                ? _c("charge-currency-total-group", {
                    key: 1,
                    attrs: {
                      "amount-to-currency": _vm.localCurrency,
                      mode: "group",
                      type: _vm.totalType,
                      "data-provider":
                        _vm.totalAmountToCurrencyBillingGrid.dataProvider,
                      "data-field": _vm.totalDataField,
                      "currency-field": _vm.totalCurrencyField,
                      "rate-field": _vm.rateField,
                      "ar-field": _vm.arField,
                      "arap-group": _vm.arapGroup,
                      "show-wht": _vm.showWht
                    }
                  })
                : _vm._e(),
              _vm.showTotalUnverifiedAmount &&
              ["tabBilling", "Writeoff"].includes(_vm.viewSource)
                ? _c("span", {
                    domProps: {
                      textContent: _vm._s(_vm.totalAmountNotWrittenOffLabel)
                    }
                  })
                : _vm._e(),
              _vm.reCalc &&
              _vm.showTotalUnverifiedAmount &&
              ["tabBilling", "Writeoff"].includes(_vm.viewSource)
                ? _c("charge-currency-total-group", {
                    key: 2,
                    attrs: {
                      "amount-to-currency": _vm.localCurrency,
                      mode: "group",
                      type: _vm.totalType,
                      "data-provider":
                        _vm.totalAmountToCurrencyBillingGrid.dataProvider,
                      "data-field": "unverifiedAmount",
                      "currency-field": _vm.totalCurrencyField,
                      "rate-field": _vm.rateField,
                      "ar-field": _vm.arField,
                      "arap-group": _vm.arapGroup,
                      "show-wht": _vm.showWht
                    }
                  })
                : _vm._e(),
              _vm.reCalc && ["MakeInvoice"].includes(_vm.viewSource)
                ? _c("charge-count-group", {
                    key: 3,
                    attrs: {
                      "selected-count":
                        _vm.totalAmountToCurrencyBillingGrid.selectedCount,
                      "data-provider":
                        _vm.totalAmountToCurrencyBillingGrid.dataProvider,
                      "display-and-count-field-list":
                        _vm.totalAmountToCurrencyBillingGrid
                          .displayAndCountFieldList,
                      "basic-currency": _vm.localCurrency,
                      "always-show": true
                    }
                  })
                : _vm._e(),
              _vm.reCalc && ["tabBilling"].includes(_vm.viewSource)
                ? _c("charge-sum-by-currency", {
                    key: 4,
                    attrs: {
                      "data-provider":
                        _vm.totalAmountToCurrencyBillingGrid.dataProvider
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.appendQuery,
                  expression: "appendQuery"
                }
              ],
              staticClass: "pagination-container"
            },
            [
              _c("el-pagination", {
                staticStyle: { "text-align": "left" },
                attrs: { total: _vm.searchConditions.total, layout: "total" }
              })
            ],
            1
          ),
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.appendQuery,
                expression: "!appendQuery"
              }
            ],
            ref: "paginationBilling",
            attrs: {
              "config-module": _vm.gridConfigModule,
              total: _vm.searchConditions.total,
              page: _vm.searchConditions.pageNum,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.searchConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: _vm.fetchDataByPage
            }
          })
        ],
        1
      ),
      _vm.workFlowApplyDialog.visible
        ? _c("bill-work-flow-apply-dialog", {
            ref: "billDialog",
            attrs: {
              "is-bpm": true,
              "process-info": _vm.workFlowApplyDialog.documentProcess,
              records: _vm.workFlowApplyDialog.approvalCommentsRecords,
              type: "approve",
              visible: _vm.workFlowApplyDialog.visible,
              "billing-uuid": _vm.workFlowApplyDialog.documentProcess.docId,
              "is-view": true
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.workFlowApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.workFlowApplyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.workFlowApplyDialog.visible = false
                _vm.fetchDataByPage()
              }
            }
          })
        : _vm._e(),
      _vm.pushLogDialog.visible
        ? _c("push-log-dialog-ql", {
            attrs: {
              visible: _vm.pushLogDialog.visible,
              uuid: _vm.pushLogDialog.uuid
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.pushLogDialog, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }